import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import style from './style.module.less';

const messages = defineMessages({
  unavailableHeader: {
    description: 'Insights is unavailable header',
    defaultMessage: 'Temporarily unavailable',
    id: 'CUwCNO',
  },
  unavailableMessage: {
    description: 'Insights is unavailable message',
    defaultMessage:
      'We have temporarily deactivated this page to decrease system load and keep shipment processing running smoothly. These insights will be back online when system usage returns to normal. Please see the Reports page to generate your own insights in the interim. We apologize for any inconvenience this may cause.',
    id: 'ODfPzw',
  },
});

const InsightsUnavailable = () => {
  return (
    <div>
      <div className={style['unavailable-header']}>
        <FormattedMessage {...messages.unavailableHeader} />
      </div>
      <div className={style['unavailable-message']}>
        <FormattedMessage {...messages.unavailableMessage} />
      </div>
    </div>
  );
};

export default InsightsUnavailable;
